<template>
    <div class="toast">
        <div class="icon" :class="type"></div>
        <div class="inside">
            <div class="Vue-Toastification__toast-body" v-html="message"></div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Toastification',
    props: {
        message: String,
        type: String
    }
});
</script>
